import numeral from "numeral";
import { IValuationIndicator } from "types/graphqlTypes";

export default function valuationIndicatorFormatValue(indicator: IValuationIndicator, value: number) {
  if (valuationIndicatorsFormatAsMoney.includes(indicator)) {
    return numeral(value).format("0.0a").replace(".0", "").replace(".", ",").toUpperCase();
  }

  if (valuationIndicatorsFormatAsPercentage.includes(indicator)) {
    return numeral(value).format("0.0%").replace(".0%", "%").replace(".", ",");
  }

  if (valuationIndicatorsFormatAsDigit.includes(indicator)) {
    return numeral(value).format("0.0").replace(".0", "").replace(".", ",");
  }

  return String(value);
}

const valuationIndicatorsFormatAsMoney = [
  // Market Cap
  IValuationIndicator.MarketCapitalization,
  IValuationIndicator.EnterpriseValue,

  // Dividends
  IValuationIndicator.RetainedEarnings,

  // Leverage
  IValuationIndicator.TotalCapital,
  IValuationIndicator.RiskWeightedAsset,
  IValuationIndicator.NonPerformingAssetsLoans,
];

const valuationIndicatorsFormatAsPercentage = [
  // Market Cap
  IValuationIndicator.CurrentQuarterlyTsoToPreviousQuarterlyTso,

  // Dividends
  IValuationIndicator.DividendYield,
  IValuationIndicator.BuyBackYield,
  IValuationIndicator.TotalYield,
  IValuationIndicator.DividendYield_5Year,
  IValuationIndicator.PayoutRatio,

  // Profitability
  IValuationIndicator.GrossMargin,
  IValuationIndicator.EbitdaMargin,
  IValuationIndicator.NormalizedEbitdaMargin,
  IValuationIndicator.EbitMargin,
  IValuationIndicator.NetInterestMargin,
  IValuationIndicator.NetInterestSpread,
  IValuationIndicator.NetMargin,
  IValuationIndicator.NormalizedNetMargin,
  IValuationIndicator.NetIncomeToNetIncomeIncludingNci,
  IValuationIndicator.NetIncomeNciToNetIncome,
  IValuationIndicator.DepreciationAndAmortizationToEbitda,
  IValuationIndicator.DepreciationAndAmortizationToNormalizedEbitda,
  IValuationIndicator.ResearchAndDevelopmentToRevenue,
  IValuationIndicator.CapexToRevenue,
  IValuationIndicator.CapexToDepreciationAndAmortization,
  IValuationIndicator.CapexToOperatingCashFlow,
  IValuationIndicator.StockBasedCompensationToFundsFromOperation,
  IValuationIndicator.StockBasedCompensationToOperatingCashFlow,
  IValuationIndicator.StockBasedCompensationToEnterpriseValue,
  IValuationIndicator.PropertyPlantAndEquipmentToTotalAssets,
  IValuationIndicator.GoodwillAndOtherIntangibleAssetsToTotalAssets,
  IValuationIndicator.GoodwillToTotalAssets,
  IValuationIndicator.Roe,
  IValuationIndicator.Roa,
  IValuationIndicator.Roic,
  IValuationIndicator.NormalizedRoic,

  // Growth
  IValuationIndicator.Revenue_5YearGrowth,
  IValuationIndicator.OperatingIncome_5YearGrowth,
  IValuationIndicator.NetIncome_5YearGrowth,
  IValuationIndicator.DilutedEps_5YearGrowth,
  IValuationIndicator.NormalizedDilutedEps_5YearGrowth,
  IValuationIndicator.Cfo_5YearGrowth,

  // Leverage
  IValuationIndicator.TotalDebtToEquity,
  IValuationIndicator.CapitalLeaseObligationsToTotalDebt,
  IValuationIndicator.InterestCoverage,
  IValuationIndicator.TotalCapitalRatio,
  IValuationIndicator.LiquidityCoverageRatio,
];

const valuationIndicatorsFormatAsDigit = [
  // Valuation
  IValuationIndicator.PriceToBook,
  IValuationIndicator.PriceToSales,
  IValuationIndicator.PriceToEbitda,
  IValuationIndicator.PriceToEps,
  IValuationIndicator.NormalizedPriceToEps,
  IValuationIndicator.PriceToFundsFromOperationsPerShare,
  IValuationIndicator.PegRatio,
  IValuationIndicator.NormalizedPegRatio,
  IValuationIndicator.PriceToCashFlow,
  IValuationIndicator.BookValuePerShare,
  IValuationIndicator.DilutedEps,
  IValuationIndicator.NormalizedDilutedEps,
  IValuationIndicator.FundsFromOperationsPerShare,

  // Market Cap
  IValuationIndicator.EnterpriseValueToRevenue,
  IValuationIndicator.EnterpriseValueToEbitda,
  IValuationIndicator.EnterpriseValueToNormalizedEbitda,
  IValuationIndicator.EnterpriseValueToEbit,

  // Dividends
  IValuationIndicator.DividendPerShare,
  IValuationIndicator.DividendPerShareToFundsFromOperationsPerShare,

  // Leverage
  IValuationIndicator.NetDebtWithLeaseToEbitda,
  IValuationIndicator.NetDebtWithoutLeaseToEbitda,
  IValuationIndicator.NetDebtWithLeaseToNormalizedEbitda,
  IValuationIndicator.NetDebtWithoutLeaseToNormalizedEbitda,
  IValuationIndicator.NetDebtWithoutLeaseToOperatingCashFlow,
  IValuationIndicator.NetDebtWithoutLeaseToFundsFromOperations,
  IValuationIndicator.CurrentRatio,
  IValuationIndicator.QuickRatio,
];
